import { colors } from '../../lib/utils/CustomTheme';
const carouselContainer = {
    bordeRadius: '8px',
    boxShadow: `${colors.transparentBlack} 0px 4px 10px 0px`,
    border: `2px solid ${colors.transparentLightGray}`,
    '& > :first-of-type': {
        opacity: 0,
        animation: 'fadeIn 0.75s forwards',
    },
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
};
const chipContainer = {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    marginBottom: '0.75rem',
};
const carouselChip = (active, isDesktop) => {
    return {
        cursor: 'pointer',
        border: 'none',
        padding: '0',
        width: active ? (isDesktop ? '90px' : '40px') : isDesktop ? '1rem' : '10px',
        height: isDesktop ? '1rem' : '10px',
        borderRadius: active ? '.5rem' : '100%',
        backgroundColor: active ? colors.brightTurquoise : colors.lightSkyBlue,
        transition: 'all 0.1s',
    };
};
export default { carouselContainer, chipContainer, carouselChip };
